<script setup lang="ts">
import './assets/style.scss'
import useModel from '../model/model'
import { onMounted, onUnmounted } from 'vue'
import { UserMenu } from '@/entities/UserMenu'
import { WEventsLastButton } from '@/widgets'

const { time, getCurrentTime } = useModel()
let interval = 0

onMounted(() => {
  getCurrentTime()

  interval = setInterval(getCurrentTime, 1000)
})

onUnmounted(() => {
  clearInterval(interval)
})
</script>

<template>
  <VToolbar>
    <div class="w-user">
      <RouterLink to="/">
        <img class="w-user__logo" src="/images/logo_lensvet_2.jpg" alt="Logo" />
      </RouterLink>

      <div class="w-user__time">{{ time }}</div>

      <VSpacer></VSpacer>

      <WEventsLastButton />

      <UserMenu />
    </div>
  </VToolbar>
</template>
